<template lang="pug">
.iPost(v-bind:style="{width: width || '300px' }").center
  .controls.relative(v-if="!noControls")
    .col.s5
      p.smallSize.center(@click="fav('love')" style="color:#00ffff" v-bind:class="{active:i.fav=='love'}") LOVE
    .col.s2
      p.smallSize.center(style="opacity:0.7" @click="unlike()") X
    .col.s5
      p.smallSize.center(@click="fav('hate')" style="color:#ff00ff" v-bind:class="{active:i.fav=='hate'}") HATE
  iframe(:width="width || '300px'" :id="i.id" :height="height || '500px'" :src="i.url.slice(0, i.url.indexOf('?')) + 'embed/captioned'" frameborder="0" scrolling="no")
  //.row
    img(:src="i.image" style="width:100%")
  //.row
    p(style="width:100%; font-size:14px;") {{i.text}}
</template>

<script>
var baseUrl = window.location.hostname == "localhost" ? "http://localhost:5500" : "";


export default {
  props: ["i", "width", "height", "noControls"],
  mounted(){
  },
  methods:{
    fav(loveorhate){
      this.i.fav = loveorhate;
      axios.get(baseUrl + "/projects/likeInstagram/" + this.i.id + "/" + loveorhate).then(({data})=>{
      });
    },
    unlike(){
      axios.get(baseUrl + "/projects/unlikeInstagram/" + this.i.id).then(({data})=>{
      });
    }
  }
}
</script>

<style lang="sass" scoped>
.iPost
  position: relative
  background-color: #FFF
  color: #000
  border-radius: 5px
  //overflow: hidden
  //&:before
    content: ''
    width: 100%
    height: 80%
    position: absolute
    left: 0
    bottom: 0
    background: linear-gradient(transparent 150px, white)
  .controls
    position: absolute
    width: 80%
    top: 0
    left: 50%
    transform: translate(-50%, 50%)
    background-color: #333
    opacity: 0
    transition: opacity 0.5s
    z-index: 100
  &:hover .controls
    opacity: 1
  .active
    border: 2px solid #666
  iframe
    border-radius: 5px
    //transform: scale(1) translate(0,-15%)
    z-index: 30
    max-width: 500px
  .line-clamp
    display: -webkit-box
    -webkit-line-clamp: 3
    -webkit-box-orient: vertical
</style>



// WEBPACK FOOTER //
// src/components/instagram.vue